import type { FC } from "react";
import type { Substitution } from "../../../../../../types/substitutions.types";
import type { Card } from "../../../../../../types/cards.types";
import type { Player } from "../../../../../../types/teams.types";
import PlayerDisplay from "../../../teams-module/components/player/player";
import * as CSS from "./subs-list.styles";

const POSITION_LABELS: Record<string, string> = {
	G: "GK",
	D: "DEF",
	M: "MID",
	F: "FWD",
};

const CardPip = ({ type }: { type: "yellow" | "red" }) => (
	<span
		style={{
			display: "inline-block",
			width: 8,
			height: 12,
			background: type === "yellow" ? "#f5c518" : "#e00",
			borderRadius: 1,
			marginLeft: 3,
			verticalAlign: "middle",
		}}
	/>
);

export type SubsListProps = {
	substitutes: Player[];
	subbedPlayers: Substitution[];
	cards: Card[];
	scorers: Map<number, number>;
};

const SubsList: FC<SubsListProps> = ({
	substitutes,
	subbedPlayers,
	cards,
	scorers,
}) => {
	const allPairs = subbedPlayers.flatMap((s) => s.subs);
	const subMap = new Map(allPairs.map((p) => [p.playerOut, p]));
	const subbedOnNames = new Set(allPairs.map((p) => p.playerIn));
	const cardsByPlayer = cards.reduce<Record<string, Card[]>>((acc, c) => {
		if (!acc[c.player]) {
			acc[c.player] = [];
		}
		acc[c.player].push(c);
		return acc;
	}, {});

	return (
		<CSS.TeamList>
			{substitutes.map((p, index) => (
				<PlayerDisplay
					key={p.id}
					player={p}
					sub={subMap.get(p.name)}
					playerCards={cardsByPlayer[p.name] ?? []}
					goals={scorers.get(p.id)}
					hasBeenSubbedOn={subbedOnNames.has(p.name)}
					showBottomBorder={index < substitutes.length - 1}
				/>
			))}
		</CSS.TeamList>
	);
};

export default SubsList;
